var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "vue-lodging" } }, [
    _c("div", { staticClass: "container" }, [
      _c("h2", [_vm._v("Lodging")]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("ul", { staticClass: "hotels-list" }, [
        _c(
          "li",
          [
            _c("hotel", {
              attrs: {
                name: "AC Hotel by Marriott",
                address: "401 E Grand Avenue",
                city: "Des Moines",
                zip: "50309",
                blockLink:
                  "http://www.marriott.com/meeting-event-hotels/group-corporate-travel/groupCorp.mi?resLinkData=Vodraska%20%7C%20Foreman%20Wedding%5EDSMAD%60VRWVRWA%7CVRWVRWB%60179.00%60USD%60false%604%609/7/18%609/9/18%6008/10/18&app=resvlink&stop_mobi=yes",
                url:
                  "http://www.marriott.com/meeting-event-hotels/group-corporate-travel/groupCorp.mi?resLinkData=Vodraska%20%7C%20Foreman%20Wedding%5EDSMAD%60VRWVRWA%7CVRWVRWB%60179.00%60USD%60false%604%609/7/18%609/9/18%6008/10/18&app=resvlink&stop_mobi=yes"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("hotel", {
              attrs: {
                name: "Staybridge Suites",
                address: "201 E Locust Street",
                city: "Des Moines",
                zip: "50301",
                blockLink:
                  "https://www.staybridge.com/redirect?path=hd&brandCode=SB&localeCode=en&regionCode=1&hotelCode=DSMSY&_PMID=99801505&GPC=VFW&viewfullsite=true",
                url:
                  "https://www.staybridge.com/redirect?path=hd&brandCode=SB&localeCode=en&regionCode=1&hotelCode=DSMSY&_PMID=99801505&GPC=VFW&viewfullsite=true"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("hotel", {
              attrs: {
                name: "Hampton Inn and Suites",
                address: "120 SW Water Street",
                city: "Des Moines",
                zip: "50309",
                url:
                  "http://hamptoninn3.hilton.com/en/hotels/iowa/hampton-inn-and-suites-des-moines-downtown-DSMWSHX/index.html"
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-113465b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-113465b2","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/views/lodging.vue
// module id = 61
// module chunks = 0